import React from 'react';
import { TableCell, Box, Stack, Typography, Chip, Tooltip } from '@mui/material';
import { Worker } from '../../../models/worker';

const getDisplayName = (worker: Worker): string => {
    const parts: string[] = [];
    if (worker.firstName) parts.push(worker.firstName);
    if (worker.prefix) parts.push(worker.prefix);
    if (worker.middleName) parts.push(worker.middleName);
    if (worker.lastName) parts.push(worker.lastName);
    return parts.length > 0 ? parts.join(' ').trim() : 'N/A';
};

// Work-authorization option keys → readable labels.
const WORK_AUTH_LABELS: Record<string, string> = {
    eu_citizen: 'EU citizen',
    work_permit: 'Work permit',
    permanent_resident: 'Permanent resident',
    student_visa: 'Student visa',
    other: 'Other',
};

const WorkerNameCell: React.FC<{ worker: Worker }> = ({ worker }) => {
    const auth = worker.workAuthorization;
    // Surface work authorization only when it signals something beyond plain EU
    // citizenship (work permit / visa / other) — i.e. the cases that matter for
    // the Non-EU tab. Keeps EU-citizen rows uncluttered.
    const showAuth = !!auth && auth !== 'eu_citizen';

    return (
        <TableCell>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Stack spacing={0.25}>
                    <Typography variant="body2" fontWeight={500}>
                        {getDisplayName(worker)}
                    </Typography>
                    {showAuth && (
                        <Tooltip title="Work authorization">
                            <Chip
                                label={WORK_AUTH_LABELS[auth as string] ?? auth}
                                size="small"
                                variant="outlined"
                                color="warning"
                                sx={{ height: 18, fontSize: '0.65rem', width: 'fit-content', '& .MuiChip-label': { px: 0.75 } }}
                            />
                        </Tooltip>
                    )}
                </Stack>
            </Box>
        </TableCell>
    );
};

export default WorkerNameCell;
